












































































import isValidPath from 'is-valid-path';
import * as R from 'ramda';
import { Component, Vue, Emit } from 'vue-property-decorator';
import CustomButton from '@/components/atoms/neon/CustomButton.vue';
import { TextRuleType } from '@/components/atoms/neon/CustomTextField.vue';
import FormDialog from '@/components/molecules/FormDialog.vue';
import { BusEventTargets } from '@/containers/globals/BusEvent';
import { i18n } from '@/plugins/i18n/i18n';
import { UploadFilesData } from '@/types/type';

@Component({
  components: {
    FormDialog,
    CustomButton,
  },
})
export default class UploadOnExecuteDialog extends Vue {
  private uploadOnExecuteEvent = BusEventTargets.UPLOAD_ON_EXECUTE_DIALOG;

  private filesData: UploadFilesData[] = [this.getEmptyFilesData()];

  private add() {
    this.filesData.push(this.getEmptyFilesData());

    //scroll to bottom
    this.$nextTick(() => {
      const el = this.$refs.fileUploadFields as Element;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    });
  }

  private remove(index: number) {
    this.filesData.splice(index, 1);
  }

  private get ruleInputRequired(): string {
    return i18n.tc('portal.ruleInputRequired');
  }

  private get rulePathValidation(): string {
    return i18n.tc('jobScheduler.jobs.invalidPath');
  }

  private get destinationFilePath(): string {
    return i18n.tc('jobScheduler.jobs.destinationFilePath');
  }

  private get addMoreLabel(): string {
    return i18n.tc('jobScheduler.jobs.addMore');
  }

  private get dialogTitle(): string {
    return i18n.tc('jobScheduler.jobs.uploadOnExecuteDialogTitle');
  }

  private get uploadFileSubtitle(): string {
    return i18n.tc('jobScheduler.jobs.uploadFileSubtitle');
  }

  private get uploadAndExecuteBtnLabel(): string {
    return i18n.tc('jobScheduler.jobs.uploadAndExecute');
  }

  private fileInputLabel(selectedFile: any): string {
    return selectedFile
      ? i18n.tc('jobScheduler.jobs.fileInput')
      : i18n.tc('jobScheduler.jobs.chooseFile');
  }

  private closeAction(): void {
    this.initializeAllData();
  }

  private get hint(): string {
    return i18n.tc('jobScheduler.jobs.hintForDestinationFilePath');
  }

  @Emit('upload-and-execute')
  private uploadAndExecute() {
    const filesToUpload = R.clone(this.filesData);
    this.initializeAllData();
    return filesToUpload;
  }

  private getEmptyFilesData() {
    return R.clone({
      destinationFilePath: '',
      selectedFile: null,
    });
  }

  private initializeAllData() {
    this.filesData = [this.getEmptyFilesData()];
  }

  private rules: { [key: string]: TextRuleType } = {
    required: value => !!value || this.ruleInputRequired,
    pathValidation: value =>
      Boolean(
        isValidPath(value) && !value.includes('\\') && value.startsWith('/')
      ) || this.rulePathValidation,
  };
}
